import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import React from 'react'
import { Link } from 'react-router-dom'
import KarteraAdminTemplate from '../../../template/KarteraAdminTemplate'
import KarteraPageHeader from '../../../template/kartera/KarteraPageHeader'
import { formatCount, RamoMark } from '../common/policy-import-common'
import { usePolicyImportExcelResultModel } from './policy-import-excel-result-model'

const primaryLinkClass = 'inline-flex h-11 items-center gap-2 rounded-xl bg-k-primary px-[18px] text-sm font-bold !text-white hover:brightness-105'
const outlineLinkClass = 'inline-flex h-11 items-center gap-2 rounded-xl border border-k-line bg-k-surface px-4 text-sm font-semibold text-k-ink hover:bg-k-hover'

const PolicyImportExcelResult = () => {
    const model = usePolicyImportExcelResultModel()

    return (
        <KarteraAdminTemplate title="Resultado de la importación">
            <div className="mx-auto flex w-full max-w-[880px] flex-col gap-[18px]">
                <KarteraPageHeader
                    title="Resultado de la importación"
                    description="Así quedó cada póliza del Excel."
                    backTo={model.backTo}
                    backLabel="Importar pólizas"
                />

                {!model.hasResults && (
                    <section className="k-card items-start">
                        <p className="m-0 text-sm text-k-ink-2">No hay resultados que mostrar. Importa un Excel para ver aquí el detalle de cada póliza.</p>
                        <Link to={model.excelPath} className={primaryLinkClass}>Importar desde Excel</Link>
                    </section>
                )}

                {model.hasResults && (
                    <>
                        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                            <div className="flex items-center gap-3.5 rounded-2xl border border-k-ok-line bg-k-ok-sunken px-4 py-3.5">
                                <CheckCircleOutlineIcon className="text-k-ok" style={{ fontSize: 28 }} />
                                <span className="flex flex-col">
                                    <span className="text-[22px] font-extrabold tabular-nums text-k-ink">{formatCount(model.imported)}</span>
                                    <span className="text-xs text-k-muted">pólizas importadas</span>
                                </span>
                            </div>
                            <div className={`flex items-center gap-3.5 rounded-2xl border px-4 py-3.5 ${model.failed > 0 ? 'border-k-danger-soft bg-k-danger-soft/40' : 'border-k-line bg-k-surface'}`}>
                                <HighlightOffIcon className={model.failed > 0 ? 'text-k-danger' : 'text-k-muted-2'} style={{ fontSize: 28 }} />
                                <span className="flex flex-col">
                                    <span className="text-[22px] font-extrabold tabular-nums text-k-ink">{formatCount(model.failed)}</span>
                                    <span className="text-xs text-k-muted">con error</span>
                                </span>
                            </div>
                        </div>

                        <section className="k-card">
                            <h2 className="k-card-title">Detalle</h2>
                            <ul className="m-0 flex list-none flex-col gap-2 p-0">
                                {model.rows.map((row) => (
                                    <li key={row.key} className={`flex items-start gap-3 rounded-[14px] border border-l-4 px-4 py-3 ${row.ok ? 'border-k-line border-l-k-ok' : 'border-k-danger-soft border-l-k-danger bg-k-danger-soft/30'}`}>
                                        <RamoMark ramo={row.ramo} boxed />
                                        <span className="flex min-w-0 flex-1 flex-col gap-0.5">
                                            <span className="flex flex-wrap items-center gap-2">
                                                <span className="text-sm font-bold tabular-nums text-k-ink">Póliza {row.noPoliza}</span>
                                                <span className="text-xs text-k-muted">Clave {row.claveAgente}</span>
                                            </span>
                                            {row.contratante && <span className="truncate text-xs text-k-ink-2">{row.contratante}</span>}
                                            {!row.ok && <span className="text-xs font-semibold text-k-danger-ink">{row.message}</span>}
                                        </span>
                                        {row.ok
                                            ? <CheckCircleOutlineIcon className="shrink-0 text-k-ok" style={{ fontSize: 20 }} />
                                            : <HighlightOffIcon className="shrink-0 text-k-danger" style={{ fontSize: 20 }} />}
                                    </li>
                                ))}
                            </ul>
                        </section>

                        <div className="flex flex-wrap items-center justify-end gap-2.5">
                            <Link to={model.excelPath} className={outlineLinkClass}>Importar otro Excel</Link>
                            <Link to={model.policiesPath} className={primaryLinkClass}>Ir a pólizas</Link>
                        </div>
                    </>
                )}
            </div>
        </KarteraAdminTemplate>
    )
}

export default PolicyImportExcelResult
